export const InfoOutlineIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.33301 3.66927H7.66634V5.0026H6.33301V3.66927ZM6.99967 10.3359C7.36634 10.3359 7.66634 10.0359 7.66634 9.66927V7.0026C7.66634 6.63594 7.36634 6.33594 6.99967 6.33594C6.63301 6.33594 6.33301 6.63594 6.33301 7.0026V9.66927C6.33301 10.0359 6.63301 10.3359 6.99967 10.3359ZM6.99967 0.335938C3.31967 0.335938 0.333008 3.3226 0.333008 7.0026C0.333008 10.6826 3.31967 13.6693 6.99967 13.6693C10.6797 13.6693 13.6663 10.6826 13.6663 7.0026C13.6663 3.3226 10.6797 0.335938 6.99967 0.335938ZM6.99967 12.3359C4.05967 12.3359 1.66634 9.9426 1.66634 7.0026C1.66634 4.0626 4.05967 1.66927 6.99967 1.66927C9.93967 1.66927 12.333 4.0626 12.333 7.0026C12.333 9.9426 9.93967 12.3359 6.99967 12.3359Z" />
  </svg>
);
